import ApiClient, { BACKEND_BASE_URL } from "../Services/ApiClient";

const DOCS_PATH = "/api-nexgent-docs";

const openApiDocs = async (): Promise<void> => {
  // Open a blank tab synchronously (direct user gesture) so the browser does
  // not block it as a popup. Note: "noopener" is intentionally NOT used here,
  // because it makes window.open() return null, and we need the handle to
  // navigate the tab to the docs URL afterwards.
  const win = window.open("", "_blank");

  try {
    // ApiClient attaches the Authorization header and withCredentials automatically.
    await ApiClient.post(
      `${BACKEND_BASE_URL}${DOCS_PATH}/authenticate`,
      {},
      { headers: { "Content-Type": "application/json" } }
    );

    const docsUrl = `${BACKEND_BASE_URL}${DOCS_PATH}/swagger-ui/index.html`;

    if (win && !win.closed) {
      win.location.href = docsUrl;
    } else {
      // Popup was blocked — last resort, navigate the current tab.
      window.location.href = docsUrl;
    }
  } catch (error) {
    if (win && !win.closed) {
      win.close();
    }
    console.error("Failed to open API documentation", error);
  }
};

export default openApiDocs;